import * as Yup from 'yup';
import { CasesGenerallCallInfo } from '../../../../../../shared/types/modules/cases-general';

export const initialValues: CasesGenerallCallInfo = {
    callId: '',
    channel: '',
    branch: '',
    product: '',
    officie: '',
    policie: '',
    plate: '',
};

export const validationSchema = () => {
    const schema: any = {
        callId: Yup.string().max(
            100,
            'El call ID debe tener 100 caracteres alfanuméricos como máximo'
        ),
        channel: Yup.string().required('El canal es obligatorio'),
        branch: Yup.string().required('La tipificación 1 es obligatoria'),
        product: Yup.string().required('El producto es obligatoria'),
        officie: Yup.string().required('La observación es obligatoria'),
        policie: Yup.string().required('La Poliza es obligatoria'),
    };

    return Yup.object(schema);
};
